<template>
  <div class="chat-wrap">
      <div class="banner-box">
        <img src="@/assets/image/banner@3x.png" alt="" />
      </div>
      <tip-tabs />
      <chat-list />
      <send-box />
      <relevant-list />
      <back-top />
  </div>
</template>

<script>
import tipTabs from "./components/tipTabs"
import chatList from "./components/chatList"
import sendBox from "./components/sendBox"
import relevantList from "./components/relevantList"
import backTop from "./components/backTop"

export default {
  components: {
    tipTabs,
    chatList,
    sendBox,
    relevantList,
    backTop
  }
}
</script>

<style lang="stylus">
.chat-wrap
  padding 15px 15px 53px
  box-sizing border-box
  .banner-box
    margin-bottom 15px
    img
      display block
      width 100%
      height auto
      border-radius 10px
</style>



// WEBPACK FOOTER //
// src/views/index.vue